import styled from 'styled-components';

export const SectionTitle = styled.div`
  color: var(--cp-text, #fff);
  //font-weight: bold;
  margin: 30px 0 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--cp-border, #595d64);
`;

export const TwoFields = styled.div`
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  position: relative;
  > div:nth-of-type(2) {
    position: absolute;
    right: 0;
    top: 0;
    /* widened so the "месяцев" option fits on one line next to the chevron */
    width: 124px;
    & div {
      width: auto;
    }
    select {
      cursor: pointer;
    }
  }
`;
